import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

const sectionProjectsAndProductions = document.getElementById("project-and-production");

if (sectionProjectsAndProductions && typeof images !== "undefined") {
    let openFullScreenLinks;
    const galleryProjectsAndProductions = new PhotoSwipeLightbox({
        dataSource: images,
        children: "a",
        pswpModule: () => import("photoswipe"),
    });
    galleryProjectsAndProductions.init();

    const openFullScreenLinksSearchAndAddListener = () => {
        openFullScreenLinks = document.querySelectorAll(".photo-swiper-el");

        openFullScreenLinks.forEach((el) => {
            el.addEventListener("click", function (event) {
                const idOnPageImage = this.getAttribute("data-id");
                const idOnArrayImage = galleryProjectsAndProductions.options.dataSource.findIndex(
                    (el) => el.id == idOnPageImage
                );
                galleryProjectsAndProductions.loadAndOpen(idOnArrayImage);
            });
        });
    };
    openFullScreenLinksSearchAndAddListener();

    let mutationObserver = new MutationObserver(function (mutations) {
        openFullScreenLinksSearchAndAddListener();
    });

    mutationObserver.observe(sectionProjectsAndProductions, {
        childList: true,
        subtree: true,
    });
}

const teamPhotoswiper = document.getElementById("team-photoswiper");

if (teamPhotoswiper) {
    const teamFullScreen = new PhotoSwipeLightbox({
        gallery: teamPhotoswiper,
        children: "a",
        pswpModule: () => import("photoswipe"),
    });
    teamFullScreen.init();
}

const serviceSlider = document.getElementById("service-slider");

if (serviceSlider) {
    const servicePhotoSlider = new PhotoSwipeLightbox({
        gallery: serviceSlider,
        children: "a",
        pswpModule: () => import("photoswipe"),
    });
    servicePhotoSlider.init();
}
